export const PICTURE_DAY_TBD = 'TBD';
export const DIGITAL_IMAGE_CATEGORY = 'DgtImages';
